var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "max-width": "560",
      "width": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "채팅상담 OpenAI 설정"
    }
  }), _c('v-card', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "outlined": ""
    }
  }, [_c('vertical-form-table', _vm._b({
    staticStyle: {
      "margin-top": "-1px"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'vertical-form-table', {
    items: _vm.items
  }, false)), _c('v-card-actions', {
    staticClass: "pa-0"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "px-4"
  }, [_c('v-switch', _vm._b({
    on: {
      "change": _vm.emit
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "text-caption"
        }, [_vm.form.openai.enabled ? [_vm._v(" 사용 ")] : [_vm._v(" 미사용 ")]], 2)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form.openai.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.form.openai, "enabled", $$v);
      },
      expression: "form.openai.enabled"
    }
  }, 'v-switch', _vm.attrs_switch__console, false))], 1), _c('v-spacer'), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _c('v-btn', _vm._b({
    attrs: {
      "text": "",
      "tile": "",
      "color": "primary",
      "height": "48"
    },
    on: {
      "click": _vm.update
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v(" mdi-content-save ")]), _vm._v(" 저장하기 ")], 1)], 1)], 1)], 1), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "light": "",
      "color": "white"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "100",
      "width": "5",
      "color": "primary",
      "indeterminate": ""
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }